import {
  ErrorOutlineOutlined,
  ReportProblemOutlined,
} from '@material-ui/icons';

import { useTLang } from 'intl/intl';

import { MOZART_COMPLAINT_REASON } from 'features/mozart-notifications/domain';
import makeClasses from './AlertBanner.style';

import type { MozartComplaintReason } from 'features/mozart-notifications/domain';

export function AlertBanner(props: Props) {
  const { seen, reason } = props;
  if (seen) return null;

  const lang = {
    reason: {
      [MOZART_COMPLAINT_REASON.DEFECT_WARNING]: {
        title: useTLang({ id: 'notification.mozart.002' }),
        description: useTLang({ id: 'notification.mozart.046' }),
      },
      [MOZART_COMPLAINT_REASON.DEFECT_GROUNDED]: {
        title: useTLang({ id: 'notification.mozart.006' }),
        description: useTLang({ id: 'notification.mozart.047' }),
      },
    },
  };

  const _classes = makeClasses();

  return (
    <div role='alert' className={_classes.alert} data-complaint-reason={reason}>
      <header>
        {reason === MOZART_COMPLAINT_REASON.DEFECT_WARNING ? (
          <ErrorOutlineOutlined fontSize='default' />
        ) : (
          <ReportProblemOutlined fontSize='default' />
        )}
        <h2 aria-label='title'>{lang.reason[reason].title}</h2>
      </header>
      <main>
        <p aria-label='description'>{lang.reason[reason].description}</p>
      </main>
    </div>
  );
}

interface Props {
  seen: boolean;
  reason: MozartComplaintReason;
}
